// extracted by mini-css-extract-plugin
var _1 = "singlePage-module_changeFileButton__M8iDhf";
var _2 = "singlePage-module_inputHidden__rwPtYL";
var _3 = "singlePage-module_removeFileButton__ThqZYU";
export { _1 as "changeFileButton", _2 as "inputHidden", _3 as "removeFileButton" }
